export default "__VITE_ASSET__BItzYjJr__"